import React from "react";
import ArrowUpIcon from "mdi-react/ChevronTripleUpIcon";
import ArrowDownIcon from "mdi-react/ChevronTripleDownIcon";
import FlatIcon from "mdi-react/MinusIcon";

export default ({ value, reverse }) => {
  const isNumber = typeof value === "number" && !isNaN(value);
  const isPositive = isNumber && value >= 0;
  const displayValue = isNumber ? Math.abs(value) : "--";
  const rotation = isNumber ? `${Math.abs(value * 1.9)}deg` : "0deg";

  return (
    <div className="semi-container">
      <div className="multigraph">
        <span className="graph" style={{ "--rotate-angle": rotation }}></span>
        <div
          className={`semiCircle_icon ${reverse ? 'reverse-color' : ''} ${
            (isPositive) ? "upward" : "downward"
          }`}
        >
          {isNumber ? (
            isPositive ? (
              <>
                <ArrowUpIcon size={36} />
                <span>{displayValue}%</span>
              </>
            ) : (
              <>
                <ArrowDownIcon size={36} />
                <span>{displayValue}%</span>
              </>
            )
          ) : (
            <>
              <span>{displayValue}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
